<template>
    <div class="dashboard-wrapper">
        <v-container fluid class="pa-4">
            <!-- Panel de Filtros -->
            <v-card class="filters-card mb-6" elevation="3">
                <v-card-title>
                    <v-icon left color="primary" size="32">mdi-trophy</v-icon>
                    <span class="text-h5 font-weight-bold">Ranking de Permisos por Trabajador</span>
                </v-card-title>
                <v-card-text>
                    <v-row dense>
                        <v-col cols="12" sm="6" md="3" class="mt-2">
                            <v-btn-toggle v-model="typePeriod" mandatory dense rounded class="mr-2">
                                <v-btn value="W" small>
                                    <v-icon left small>mdi-calendar-week</v-icon>Semana
                                </v-btn>
                                <v-btn value="M" small>
                                    <v-icon left small>mdi-calendar-month</v-icon>Mes
                                </v-btn>
                                <v-btn value="R" small>
                                    <v-icon left small>mdi-calendar-range</v-icon>Rango
                                </v-btn>
                            </v-btn-toggle>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                            <s-date label="Fecha Desde" v-model="dateFrom" @change="loadData()" outlined dense clearable />
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                            <s-date label="Fecha Hasta" v-model="dateTo" @change="loadData()" outlined dense clearable />
                        </v-col>
                        <v-col cols="12" sm="6" md="3" class="mt-2">
                            <v-btn-toggle v-model="typeMetric" mandatory dense rounded>
                                <v-btn value="count" small>
                                    <v-icon left small>mdi-pound</v-icon>Cantidad
                                </v-btn>
                                <v-btn value="duration" small>
                                    <v-icon left small>mdi-timer-outline</v-icon>Duración
                                </v-btn>
                            </v-btn-toggle>
                        </v-col>
                    </v-row>
                    <v-row dense class="mt-2">
                        <v-col cols="12" sm="6" md="3">
                            <s-select-definition
                                label="Tipo de Permiso"
                                v-model="filterMotive"
                                :def="1428"
                                clearable
                                outlined
                                dense
                                @change="loadData()"
                            />
                        </v-col>
                        <v-col cols="12" sm="6" md="2" class="mt-2">
                            <v-btn color="primary" @click="loadData()" :loading="loading" block>
                                <v-icon left>mdi-refresh</v-icon>Actualizar
                            </v-btn>
                        </v-col>
                    </v-row>

                    <!-- Datos cargados -->
                    <div v-if="items.length > 0" class="mt-6">

                        <!-- Tarjetas de trabajadores -->
                        <transition-group name="card-move" tag="div" class="workers-grid">
                            <v-col
                                v-for="(item, index) in sortedItems"
                                :key="item.PrsID"
                                cols="12" xs="12" sm="6" md="4" lg="3" xl="2"
                                class="worker-col"
                            >
                                <v-card
                                    class="worker-card"
                                    elevation="6"
                                    :class="{
                                        'top-offender':   isTop3Performer(item),
                                        'best-performer': isBottomPerformer(item),
                                        'worst-place':    isTopPerformer(item),
                                        'card-flash':     isCardFlashing(item),
                                        'position-changed': hasPositionChanged(item)
                                    }"
                                >

                                    <!-- Alerta roja para el #1 (más permisos/tiempo) -->
                                    <div class="alert-badge" v-if="isTopPerformer(item)">
                                        <v-icon color="white" size="20">mdi-alert</v-icon>
                                        <span>1°</span>
                                    </div>

                                    <!-- Ribbon ALERTA para los top 3 -->
                                    <div class="card-ribbon" v-if="isTop3Performer(item) && !isTopPerformer(item)">
                                        <v-icon small color="white">mdi-alert-circle-outline</v-icon>
                                        ALERTA
                                    </div>

                                    <!-- Estrella ámbar para el último (el menos ausente) -->
                                    <div class="star-badge" v-if="isBottomPerformer(item)">
                                        <v-icon color="white" size="20">mdi-star</v-icon>
                                    </div>

                                    <v-card-text class="pa-4">
                                        <div class="d-flex justify-space-between align-center flex-wrap">
                                            <!-- Nombre del trabajador -->
                                            <div class="text-left worker-info">
                                                <div class="worker-name">{{ item.NtpName }}</div>
                                                <div class="worker-lastname">{{ item.NtpPaternalSurname }} {{ item.NtpMaternalSurname }}</div>
                                            </div>

                                            <!-- Métrica principal -->
                                            <div class="box-counter text-right">
                                                <v-icon
                                                    :color="isTopPerformer(item) ? 'red darken-2' : isBottomPerformer(item) ? 'amber darken-3' : 'deep-purple darken-1'"
                                                    :size="32"
                                                >
                                                    {{ typeMetric === 'count' ? 'mdi-clipboard-list' : 'mdi-timer-outline' }}
                                                </v-icon>

                                                <div class="box-number-container">
                                                    <transition name="slide-up">
                                                        <span
                                                            :key="mainValue(item)"
                                                            class="box-number"
                                                            :class="{ 'red-text': isTopPerformer(item), 'amber-text': isBottomPerformer(item) }"
                                                        >
                                                            {{ mainValue(item) }}
                                                        </span>
                                                    </transition>
                                                </div>
                                                <span
                                                    class="box-label"
                                                    :class="{ 'red-text': isTopPerformer(item), 'amber-text': isBottomPerformer(item) }"
                                                >
                                                    {{ typeMetric === 'count' ? 'PERMISOS' : 'MINUTOS' }}
                                                </span>
                                            </div>
                                        </div>

                                        <!-- Datos secundarios -->
                                        <v-divider class="my-2" />
                                        <div class="d-flex justify-space-between secondary-stats">
                                            <div>
                                                <v-icon x-small color="grey">mdi-clipboard-list</v-icon>
                                                <span class="caption ml-1">{{ item.TotalPermissions }} perm.</span>
                                            </div>
                                            <div>
                                                <v-icon x-small color="grey">mdi-timer-outline</v-icon>
                                                <span class="caption ml-1">{{ item.TotalMinutes }} min.</span>
                                            </div>
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </transition-group>

                        <!-- Tarjetas de estadísticas -->
                        <v-row class="mb-4 mt-8 justify-end">
                            <v-col cols="12" sm="6" md="4" lg="3">
                                <v-card class="stat-card" color="primary" dark elevation="4">
                                    <v-card-text class="text-center pa-4">
                                        <v-icon size="40" class="mb-2">mdi-account-group</v-icon>
                                        <div class="stat-number-container">
                                            <transition name="slide-up" mode="out-in">
                                                <div :key="items.length" class="stat-number">{{ items.length }}</div>
                                            </transition>
                                        </div>
                                        <div class="stat-label">Trabajadores</div>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="12" sm="6" md="4" lg="3">
                                <v-card class="stat-card" color="deep-purple" dark elevation="4">
                                    <v-card-text class="text-center pa-4">
                                        <v-icon size="40" class="mb-2">mdi-clipboard-list</v-icon>
                                        <div class="stat-number-container">
                                            <transition name="slide-up" mode="out-in">
                                                <div :key="totalPermissions" class="stat-number">{{ totalPermissions }}</div>
                                            </transition>
                                        </div>
                                        <div class="stat-label">Total Permisos</div>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <v-col cols="12" sm="6" md="4" lg="3">
                                <v-card class="stat-card" color="orange darken-2" dark elevation="4">
                                    <v-card-text class="text-center pa-4">
                                        <v-icon size="40" class="mb-2">mdi-timer-outline</v-icon>
                                        <div class="stat-number-container">
                                            <transition name="slide-up" mode="out-in">
                                                <div :key="totalMinutes" class="stat-number">{{ totalMinutes }}</div>
                                            </transition>
                                        </div>
                                        <div class="stat-label">Total Minutos</div>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>

                        <!-- Tabla resumen -->
                        <v-card class="mt-4" elevation="2">
                            <v-card-title class="subtitle-1 font-weight-bold">
                                <v-icon left color="deep-purple">mdi-table</v-icon>
                                Resumen
                            </v-card-title>
                            <v-data-table
                                :headers="tableHeaders"
                                :items="sortedItems"
                                :items-per-page="15"
                                dense
                                class="elevation-0"
                            >
                                <template v-slot:item.position="{ item }">
                                    <v-chip small :color="getRankColor(getWorkerRank(item))" dark>
                                        {{ getWorkerRank(item) }}°
                                    </v-chip>
                                </template>
                                <template v-slot:item.fullNamePerson="{ item }">
                                    <strong>{{ item.NtpPaternalSurname }} {{ item.NtpMaternalSurname }}, {{ item.NtpName }}</strong>
                                </template>
                                <template v-slot:item.TotalPermissions="{ item }">
                                    <v-chip small color="deep-purple lighten-4">{{ item.TotalPermissions }}</v-chip>
                                </template>
                                <template v-slot:item.TotalMinutes="{ item }">
                                    <v-chip small color="orange lighten-4">{{ item.TotalMinutes }} min</v-chip>
                                </template>
                            </v-data-table>
                        </v-card>
                    </div>

                    <!-- Estado vacío -->
                    <div v-else>
                        <v-card class="empty-state" elevation="3">
                            <v-card-text class="text-center pa-12">
                                <v-icon size="120" color="grey lighten-1" class="mb-6">mdi-trophy-outline</v-icon>
                                <h1 class="text-h4 mb-4 grey--text text--darken-1">
                                    {{ loading ? 'Cargando datos...' : 'Sin datos en el período seleccionado' }}
                                </h1>
                                <p class="text-subtitle-1 grey--text">
                                    Ajuste los filtros de fecha y haga clic en Actualizar
                                </p>
                                <v-btn color="primary" large class="mt-6" @click="loadData()" outlined :loading="loading">
                                    <v-icon left>mdi-refresh</v-icon>
                                    Actualizar
                                </v-btn>
                            </v-card-text>
                        </v-card>
                    </div>
                </v-card-text>
            </v-card>
        </v-container>
    </div>
</template>

<script>
import _sPermissionsPersonByGroup from '@/services/FrozenProduction/FrzPermissionsPersonByGroup.js';

export default {
    data() {
        return {
            items: [],
            loading: false,
            typePeriod: 'W',        // 'W' = semana, 'M' = mes, 'R' = rango
            typeMetric: 'count',    // 'count' = cantidad, 'duration' = duración
            filterMotive: null,
            dateFrom: null,
            dateTo: null,
            flashingCards: new Set(),
            positionChangedCards: new Set(),
            previousValues: {},
            previousPositions: {},
            windowWidth: window.innerWidth,
            tableHeaders: [
                { text: 'Pos.', value: 'position', sortable: false, width: 70 },
                { text: 'Trabajador', value: 'fullNamePerson', sortable: false },
                { text: 'Total Permisos', value: 'TotalPermissions', align: 'center' },
                { text: 'Total Minutos', value: 'TotalMinutes', align: 'center' },
            ],
        };
    },

    computed: {
        sortedItems() {
            const key = this.typeMetric === 'count' ? 'TotalPermissions' : 'TotalMinutes';
            return [...this.items].sort((a, b) => b[key] - a[key]);
        },
        topPerformer() {
            return this.sortedItems.length > 0 ? this.sortedItems[0] : null;
        },
        top3Workers() {
            return this.sortedItems.slice(0, 3);
        },
        totalPermissions() {
            return this.items.reduce((sum, i) => sum + (i.TotalPermissions || 0), 0);
        },
        totalMinutes() {
            return this.items.reduce((sum, i) => sum + (i.TotalMinutes || 0), 0);
        },
    },

    watch: {
        typePeriod(val) {
            this.applyPeriod(val);
            this.loadData();
        },
        typeMetric() {
            // Solo re-ordena, no recarga
        },
    },

    methods: {
        applyPeriod(period) {
            const today = this.$moment();
            if (period === 'W') {
                this.dateFrom = today.clone().startOf('isoWeek').format('YYYY-MM-DD');
                this.dateTo   = today.clone().endOf('isoWeek').format('YYYY-MM-DD');
            } else if (period === 'M') {
                this.dateFrom = today.clone().startOf('month').format('YYYY-MM-DD');
                this.dateTo   = today.clone().endOf('month').format('YYYY-MM-DD');
            }
            // 'R' = rango libre, no toca las fechas
        },

        mainValue(item) {
            return this.typeMetric === 'count' ? item.TotalPermissions : item.TotalMinutes;
        },

        getWorkerKey(item) {
            return `${item.PrsID}`;
        },

        isTopPerformer(item) {
            return this.topPerformer && item.PrsID === this.topPerformer.PrsID;
        },
        isTop3Performer(item) {
            return this.top3Workers.some(w => w.PrsID === item.PrsID);
        },
        isBottomPerformer(item) {
            if (this.sortedItems.length < 2) return false;
            return item.PrsID === this.sortedItems[this.sortedItems.length - 1].PrsID;
        },
        getWorkerRank(item) {
            return this.sortedItems.findIndex(w => w.PrsID === item.PrsID) + 1;
        },
        getRankColor(rank) {
            const last = this.sortedItems.length;
            if (rank === last) return 'amber darken-2';        // el menos ausente
            if (rank === 1)    return 'red darken-2';           // el que más permisos/tiempo tiene
            if (rank === 2)    return 'orange darken-2';
            if (rank === 3)    return 'orange lighten-1';
            return 'grey lighten-1';
        },
        isCardFlashing(item) {
            return this.flashingCards.has(this.getWorkerKey(item));
        },
        hasPositionChanged(item) {
            return this.positionChangedCards.has(this.getWorkerKey(item));
        },

        loadData() {
            this.loading = true;
            const params = {
                DateFrom:    this.dateFrom || this.$fun.getDate(),
                DateTo:      this.dateTo   || this.$fun.getDate(),
                TypePeriod:  this.typePeriod,
                PpgMotive:   this.filterMotive || 0,
            };

            _sPermissionsPersonByGroup
                .ranking(params, this.$fun.getUserID())
                .then(resp => {
                    if (resp.status === 200) {
                        const newItems = resp.data;

                        // Calcular posiciones para animaciones
                        const key = this.typeMetric === 'count' ? 'TotalPermissions' : 'TotalMinutes';
                        const sorted = [...newItems].sort((a, b) => b[key] - a[key]);
                        const currentPositions = {};
                        sorted.forEach((item, index) => {
                            currentPositions[this.getWorkerKey(item)] = index;
                        });

                        newItems.forEach(item => {
                            const k = this.getWorkerKey(item);
                            const prevVal = this.previousValues[k];
                            const prevPos = this.previousPositions[k];
                            const curPos  = currentPositions[k];
                            const curVal  = this.mainValue(item);

                            if (prevVal !== undefined && prevVal !== curVal) {
                                this.flashingCards.add(k);
                                setTimeout(() => {
                                    this.flashingCards.delete(k);
                                    this.$forceUpdate();
                                }, 1000);
                            }
                            if (prevPos !== undefined && prevPos !== curPos) {
                                this.positionChangedCards.add(k);
                                setTimeout(() => {
                                    this.positionChangedCards.delete(k);
                                    this.$forceUpdate();
                                }, 800);
                            }
                            this.previousValues[k]    = curVal;
                            this.previousPositions[k] = curPos;
                        });

                        this.items = newItems;
                    }
                })
                .catch(err => {
                    console.error('Error cargando ranking de permisos', err);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        handleResize() {
            this.windowWidth = window.innerWidth;
        },
    },

    created() {
        this.applyPeriod(this.typePeriod);
        this.loadData();
    },

    mounted() {
        window.addEventListener('resize', this.handleResize);
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
};
</script>

<style scoped>
.dashboard-wrapper {
    background: linear-gradient(135deg, #f5f7fa 0%, #ede9f5 100%);
    min-height: 100vh;
    padding-bottom: 40px;
}

.filters-card {
    border-radius: 12px !important;
    background: white;
}

/* ---- GRID DE TARJETAS ---- */
.workers-grid {
    display: flex;
    flex-wrap: wrap;
    margin: -12px;
}

.worker-col {
    padding: 12px;
    transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

.worker-card {
    border-radius: 16px !important;
    transition: all 0.3s ease;
    position: relative;
    overflow: visible;
    border: 2px solid transparent;
    height: 100%;
    display: flex;
    flex-direction: column;
    animation: fadeInUp 0.5s ease forwards;
}

.worker-card:hover {
    transform: translateY(-8px);
    box-shadow: 0 12px 28px rgba(0, 0, 0, 0.2) !important;
    border-color: #7c4dff;
}

/* ---- TOP OFFENDERS (más permisos = peor) ---- */
.top-offender {
    background: linear-gradient(135deg, #fff3e0 0%, #ffffff 100%);
    border-color: #ef6c00 !important;
}

.worst-place {
    border: 3px solid #ef5350 !important;
    background: linear-gradient(135deg, #fff8f8 0%, #ffffff 100%);
}

/* ---- LEAST BAD (menos permisos, pero igual tiene) ---- */
.best-performer {
    background: linear-gradient(135deg, #fff8e1 0%, #ffffff 100%);
    border: 2px solid #ffb300 !important;
}

/* ---- BADGES ---- */
.position-badge {
    position: absolute;
    top: 8px;
    right: 8px;
    background: linear-gradient(135deg, #7c4dff 0%, #512da8 100%);
    color: white;
    font-weight: bold;
    font-size: 0.85rem;
    padding: 4px 10px;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(124, 77, 255, 0.4);
    z-index: 2;
}

/* Badge de alerta para el #1 (peor desempeño) */
.alert-badge {
    position: absolute;
    top: -12px;
    left: -12px;
    background: linear-gradient(135deg, #ef5350 0%, #b71c1c 100%);
    width: 45px;
    height: 45px;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-shadow:
        0 4px 15px rgba(239, 83, 80, 0.6),
        0 0 20px rgba(239, 83, 80, 0.4);
    z-index: 10;
    border: 3px solid white;
    animation: alertPulse 1.5s ease-in-out infinite;
}

.alert-badge span {
    color: white;
    font-weight: bold;
    font-size: 0.85rem;
    margin-top: -2px;
}

/* Badge ámbar para el último (el menos ausente) */
.star-badge {
    position: absolute;
    top: -12px;
    left: -12px;
    background: linear-gradient(135deg, #ffb300 0%, #e65100 100%);
    width: 45px;
    height: 45px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow:
        0 4px 15px rgba(255, 179, 0, 0.6),
        0 0 20px rgba(255, 179, 0, 0.4);
    z-index: 10;
    border: 3px solid white;
    animation: starBounce 2s ease-in-out infinite;
}

.card-ribbon {
    position: absolute;
    top: -12px;
    right: -5px;
    background: linear-gradient(135deg, #ef6c00 0%, #bf360c 100%);
    color: white;
    padding: 4px 12px;
    font-size: 0.7rem;
    font-weight: bold;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(239, 108, 0, 0.4);
    z-index: 1;
    display: flex;
    align-items: center;
    gap: 4px;
}

/* (clase sad-badge eliminada, reemplazada por star-badge y alert-badge) */

/* ---- NOMBRES ---- */
.worker-info {
    flex: 1 1 auto;
    min-width: 0;
}

.worker-name {
    font-size: 1.3rem;
    font-weight: bold;
    color: #2c3e50;
    margin-bottom: 4px;
    word-wrap: break-word;
}

.worker-lastname {
    font-size: 1rem;
    color: #7f8c8d;
    font-weight: 500;
    word-wrap: break-word;
}

/* ---- MÉTRICA ---- */
.box-counter {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    flex-shrink: 0;
    margin-left: 8px;
}

.box-number-container {
    position: relative;
    height: 3rem;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
}

.box-number {
    font-size: 3rem;
    font-weight: bold;
    color: #7c4dff;
    line-height: 1;
    display: block;
}

.box-label {
    font-size: 0.85rem;
    color: #7c4dff;
    font-weight: 600;
    letter-spacing: 2px;
}

.red-text   { color: #e53935 !important; }
.amber-text { color: #f57f17 !important; }

.secondary-stats {
    font-size: 0.8rem;
    color: #666;
}

/* ---- STAT CARDS ---- */
.stat-card {
    border-radius: 12px !important;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    height: 100%;
}

.stat-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15) !important;
}

.stat-number {
    font-size: 2.5rem;
    font-weight: bold;
    margin: 8px 0;
}

.stat-number-container {
    position: relative;
    height: 3rem;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
}

.stat-label {
    font-size: 0.9rem;
    opacity: 0.9;
    text-transform: uppercase;
    letter-spacing: 1px;
}

/* ---- EMPTY STATE ---- */
.empty-state {
    border-radius: 16px !important;
    margin-top: 40px;
    background: white;
}

/* ---- ANIMACIONES ---- */
@keyframes fadeInUp {
    from { opacity: 0; transform: translateY(20px); }
    to   { opacity: 1; transform: translateY(0); }
}

@keyframes alertPulse {
    0%, 100% { transform: scale(1);    box-shadow: 0 4px 15px rgba(239,83,80,0.5); }
    50%       { transform: scale(1.12); box-shadow: 0 4px 25px rgba(239,83,80,0.9); }
}

@keyframes starBounce {
    0%, 100% { transform: translateY(0) rotate(0deg); }
    50%       { transform: translateY(-5px) rotate(15deg); }
}

@keyframes flashPulse {
    0%, 100% {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        transform: scale(1);
    }
    50% {
        box-shadow: 0 0 40px rgba(124, 77, 255, 0.8), 0 0 80px rgba(124, 77, 255, 0.4);
        transform: scale(1.06);
    }
}

@keyframes positionChange {
    0%   { transform: scale(1); }
    50%  { transform: scale(1.08) translateY(-10px); box-shadow: 0 0 40px rgba(124, 77, 255, 0.8); }
    100% { transform: scale(1); }
}

.card-flash { animation: flashPulse 1s ease-in-out; }
.position-changed { animation: positionChange 0.8s cubic-bezier(0.4, 0, 0.2, 1); }

/* Slide-up para números */
.slide-up-leave-active { transition: all 0.4s cubic-bezier(0.4, 0, 1, 1); position: absolute; }
.slide-up-leave-to    { opacity: 0; transform: translateY(-100%); }
.slide-up-enter-active { transition: all 0.5s cubic-bezier(0, 0, 0.2, 1); }
.slide-up-enter       { opacity: 0; transform: translateY(100%); }
.slide-up-enter-to    { opacity: 1; transform: translateY(0); }

/* Card-move transition */
.card-move-move         { transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1); }
.card-move-enter-active { transition: all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1); }
.card-move-leave-active { transition: all 0.4s ease-out; position: absolute; }
.card-move-enter        { opacity: 0; transform: translateY(30px) scale(0.9); }
.card-move-leave-to     { opacity: 0; transform: translateY(-30px) scale(0.9); }

/* Responsive */
@media (max-width: 599px) {
    .worker-name { font-size: 1.1rem; }
    .worker-lastname { font-size: 0.9rem; }
    .box-number { font-size: 2.5rem; }
    .box-number-container { height: 2.5rem; }
    .champion-badge, .sad-badge { width: 38px; height: 38px; }
}
</style>
